import { createFileRoute, Link, useRouter } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { Button } from "@/components/ui/button/button";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";

import type { JSX } from "react";

const ContactsHistoryAboutPage = (): JSX.Element => {
  const router = useRouter();

  const handleClickBackButton = (): void => {
    router.history.back();
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" aria-label="Voltar" />
        <HeaderTitle title="Sobre" />
      </HeaderRoot>

      <Page>
        <div className="mt-4">
          <h2 className="text-xl font-medium text-neutral-600">Raio-X de Contatos</h2>
          <p className="text-gray-700 text-md mt-2">
            Aqui você acompanha todos os contatos atendidos no período, com o valor
            previsto correspondente.
          </p>

          <div className="mt-6 flex flex-col gap-4">
            <div>
              <h2 className="font-semibold mb-1">
                O valor exibido aqui é o mesmo que vou pagar no Assist Pro?
              </h2>
              <p className="text-gray-700 mb-2">
                Não. O valor mostrado é o total relativo aos contatos atendidos no período
                selecionado – não inclui a mensalidade nem os abonos. Para acompanhar
                todos os valores considerados na sua fatura, acesse o{" "}
                <Link
                  to="/settings/billing"
                  className="text-helper-600 underline font-medium"
                >
                  Histórico de Uso
                </Link>
                .
              </p>
            </div>

            <div>
              <h2 className="font-semibold mb-1">Posso ver mais detalhes?</h2>
              <p className="text-gray-700 mb-2">
                Sim. Toque no contato para abrir todas as informações.
              </p>
            </div>

            <div>
              <h2 className="font-semibold mb-1">
                Posso solicitar revisão de um contato?
              </h2>
              <p className="text-gray-700 mb-2">
                Sim. Você pode pedir auditoria diretamente pelo nosso canal{" "}
                <a
                  href="https://api.whatsapp.com/send/?phone=551132304410&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-helper-600 underline font-medium"
                >
                  aqui
                </a>
                .
              </p>
            </div>

            <div>
              <h2 className="font-semibold mb-1">Quer saber mais?</h2>
              <p className="text-gray-700">
                Confira dicas e respostas rápidas na nossa{" "}
                <a
                  href="https://ajuda.livance.com.br/hc/pt-br/articles/41381084919699-Perguntas-Frequentes"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-helper-600 underline font-medium"
                >
                  Central de Ajuda
                </a>
                .
              </p>
            </div>
          </div>
        </div>

        <Button
          className="mt-6"
          onClick={handleClickBackButton}
          fullWidth
          data-testid="back-button"
        >
          Voltar
        </Button>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/contacts-history/about/")({
  component: ContactsHistoryAboutPage,
});
